@let u = user();

<mat-card
	tabindex="0"
	class="card"
	[class.disabled]="isNavigating()"
	appearance="outlined"
	[attr.aria-busy]="isNavigating()"
	[attr.aria-disabled]="isNavigating()"
	(click)="onCardSelected()"
	(keydown.enter)="onCardSelected()"
>
	<mat-card-title class="text truncate" [aria-label]="'user.specialist_card.user' | transloco">
		{{ u.fullName }}
	</mat-card-title>
	<mat-card-content class="panel">
		<p class="text truncate">{{ 'user.specialist_card.service' | transloco }} {{ u.serviceName }}</p>
		<p class="text truncate">{{ 'user.specialist_card.ifd' | transloco }} {{ u.ifdName }}</p>
	</mat-card-content>
</mat-card>
